import AbstractApi, { type RequestConfig } from '@/api/AbstractApi';

export default class AbstractHybrisFnApi extends AbstractApi {
  baseStore: string;

  constructor(config: RequestConfig) {
    super(config);

    this.baseUrl = config.public.hybrisFnBaseUrl;
    this.baseStore = '';
  }

  override getURL(endpoint: string) {
    return `${this.baseUrl}/${this.baseStore}${endpoint}`;
  }
}
